// Shared labels for the Aquaman admin UI.

export const LEAVE_RULE_OPTIONS = [
  { value: "any_day", label: "Edhe një ditë leje e kalon javën" },
  { value: "most_of_week", label: "Mbi gjysmën e javës me leje" },
  { value: "full_week", label: "Vetëm javë e plotë me leje" },
];

export const WEEK_STATUS = {
  assigned: { label: "Caktuar", color: "green" },
  covered: { label: "Zëvendësim", color: "orange" },
  skipped: { label: "Pa shërbim", color: "default" },
  unassigned: { label: "Pa caktuar", color: "red" },
};

export const WARNING_LABELS = {
  holiday_week: "Javë me festa: nuk caktohet njeri.",
  empty_roster: "Lista e rotacionit është bosh.",
  everyone_on_leave: "Të gjithë kandidatët janë me leje këtë javë.",
  cooldown_relaxed:
    "Pauza pas radhës u anashkalua sepse nuk kishte kandidat tjetër.",
  swap_pending:
    "Një zëvendësim është në pritje: personi me leje merr javën e zëvendësuesit sapo kthehet.",
};
